module.exports = __webpack_public_path__ + "static/the-year-without-pants-763680ac498992d0a7e1b5c7979fb0ea.jpg";